/**
 * Leaflet-kirjaston keskitetty konfigurointi
 * Importoidaan kerran karttakomponentteihin sivuvaikutuksena
 */
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Korjataan Leaflet marker-ikonit bundler-ympäristössä
// Webpack/Vite ei käsittele Leafletin oletus-ikoneja oikein
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const proto = L.Icon.Default.prototype as any;
if (proto._getIconUrl) {
  delete proto._getIconUrl;
}

L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});

// Tyhjä export tekee tästä moduulin - import suorittaa sivuvaikutuksen
export {};
